import { Helmet } from 'react-helmet-async';
import Settings from '../../../components/dashboard/transports/Settings/Settings';

export default function TransportsSettings() {
  return (
    <>
      <Helmet>
        <title>Transports Settings | Platform Solutions</title>
      </Helmet>
      <Settings />
    </>
  );
}
